import { BACKEND_URI } from "../entries";
import { secureAPICall } from "../utils/sessionUtils";

// QUICK REPLIES REQUESTS

export const requestQuickReplies = async ({ verbose = false }) => {
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/fetch-quick-replies",
    verbose: verbose,
  });
};

export const requestSubmitNewQuickReply = async ({
  title,
  message,
  verbose = false,
}) => {
  const formData = new FormData();
  formData.append("title", title);
  formData.append("message", message);
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/submit-new-quick-reply",
    body: formData,
    verbose: verbose,
  });
};

export const requestEditQuickReply = async ({
  id,
  title,
  message,
  verbose,
}) => {
  const formData = new FormData();
  formData.append("id", id);
  formData.append("title", title);
  formData.append("message", message);
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/edit-quick-reply",
    body: formData,
    verbose: verbose,
  });
};

export const requestDeleteQuickReply = async ({ id, verbose }) => {
  const formData = new FormData();
  formData.append("id", id);
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/delete-quick-reply",
    body: formData,
    verbose: verbose,
  });
};

export const requestAddCategoriesToQuickReply = async ({
  id,
  categories,
  verbose,
}) => {
  const formData = new FormData();
  formData.append("id", id);
  categories.forEach((category) => {
    formData.append("categories", category);
  });
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/add-categories-to-quick-reply",
    body: formData,
    verbose: verbose,
  });
};

export const requestQuickRepliesForCategory = async ({
  category,
  verbose = false,
}) => {
  const formData = new FormData();
  formData.append("category", category);
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/fetch-category-quick-replies",
    body: formData,
    verbose: verbose,
  });
};

// CATEGORIES REQUESTS

export const requestCategories = async ({ verbose = false }) => {
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/fetch-categories",
    verbose: verbose,
  });
};

export const requestDeletedCategories = async ({ verbose = false }) => {
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/fetch-deleted-categories",
    verbose: verbose,
  });
};

export const requestCategoryTicketNumbers = async ({ verbose = false }) => {
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/fetch-category-ticket-numbers",
    verbose: verbose,
  });
};

export const requestSubmitNewCategory = async ({
  title,
  value,
  style,
  locales,
  hasViolatersForm,
  verbose = false,
}) => {
  const formData = new FormData();
  formData.append("title", title);
  formData.append("value", value);
  formData.append("style", style);
  formData.append("has_violaters_form", hasViolatersForm);
  if (Object.keys(locales).length === 0) {
    formData.append("locales", null);
  }

  for (let i = 0; i < Object.keys(locales).length; i++) {
    let locale = Object.entries(locales)[i];
    formData.append("locales", `${locale[0]}____${locale[1]}`);
  }
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/submit-new-category",
    body: formData,
    verbose: verbose,
  });
};

export const requestEditCategory = async ({
  id,
  title,
  value,
  style,
  locales,
  hasViolatersForm,
  verbose = false,
}) => {
  const formData = new FormData();
  formData.append("title", title);
  formData.append("value", value);
  formData.append("style", style);
  formData.append("has_violaters_form", hasViolatersForm);
  for (let i = 0; i < Object.keys(locales).length; i++) {
    let locale = Object.entries(locales)[i];
    formData.append("locales", `${locale[0]}____${locale[1]}`);
  }
  formData.append("id", id);
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/edit-category",
    body: formData,
    verbose: verbose,
  });
};

export const requestDeleteCategory = async ({ id, verbose = false }) => {
  const formData = new FormData();
  formData.append("id", id);
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/delete-category",
    body: formData,
    verbose: verbose,
  });
};

export const requestDisableCategory = async ({ id, verbose = false }) => {
  const formData = new FormData();
  formData.append("id", id);
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/disable-category",
    body: formData,
    verbose: verbose,
  });
};

export const requestEnableCategory = async ({ id, verbose = false }) => {
  const formData = new FormData();
  formData.append("id", id);
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/enable-category",
    body: formData,
    verbose: verbose,
  });
};

// PRIORITIES REQUESTS

export const requestPriorityLevels = async ({ verbose = false }) => {
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/fetch-priority-levels",
    verbose: verbose,
  });
};

export const requestDeletedPriorityLevels = async ({ verbose = false }) => {
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/fetch-deleted-priority-levels",
    verbose: verbose,
  });
};

export const requestSubmitNewPriorityLevel = async ({
  title,
  value,
  style,
  verbose = false,
}) => {
  const formData = new FormData();
  formData.append("title", title);
  formData.append("value", value);
  formData.append("style", style);
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/submit-new-priority-level",
    body: formData,
    verbose: verbose,
  });
};

export const requestEditPriorityLevel = async ({
  id,
  title,
  value,
  style,
  verbose = false,
}) => {
  const formData = new FormData();
  formData.append("title", title);
  formData.append("value", value);
  formData.append("style", style);
  formData.append("id", id);
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/edit-priority-level",
    body: formData,
    verbose: verbose,
  });
};

export const requestDeletePriorityLevel = async ({ id, verbose = false }) => {
  const formData = new FormData();
  formData.append("id", id);
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/delete-priority-level",
    body: formData,
    verbose: verbose,
  });
};

export const requestSetDefaultPriorityLevel = async ({
  id,
  verbose = false,
}) => {
  const formData = new FormData();
  formData.append("id", id);
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/set-default-priority",
    body: formData,
    verbose: verbose,
  });
};

// ANNOUNCEMENTS REQUESTS

export const requestAnnouncements = async ({
  hasPermission = false,
  verbose = false,
}) => {
  const formData = new FormData();
  formData.append("hasPermission", hasPermission);
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/fetch-announcements",
    body: formData,
    verbose: verbose,
  });
};

export const requestSubmitNewAnnouncement = async ({
  title,
  engTitle,
  message,
  engMessage,
  value,
  startDate,
  endDate,
  verbose = false,
}) => {
  const formData = new FormData();
  formData.append("title", title);
  formData.append("engTitle", engTitle);
  formData.append("message", message);
  formData.append("engMessage", engMessage);
  formData.append("value", value);
  formData.append("startDate", startDate);
  formData.append("endDate", endDate);
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/submit-new-announcement",
    body: formData,
    verbose: verbose,
  });
};

export const requestEditAnnouncement = async ({
  id,
  title,
  engTitle,
  message,
  engMessage,
  value,
  startDate,
  endDate,
  verbose = false,
}) => {
  const formData = new FormData();
  formData.append("id", id);
  formData.append("title", title);
  formData.append("engTitle", engTitle);
  formData.append("message", message);
  formData.append("engMessage", engMessage);
  formData.append("value", value);
  formData.append("startDate", startDate);
  formData.append("endDate", endDate);
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/edit-announcement",
    body: formData,
    verbose: verbose,
  });
};

export const requestChangeActiveAnnouncement = async ({
  id,
  active,
  verbose = false,
}) => {
  const formData = new FormData();
  formData.append("id", id);
  formData.append("active", active);
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/change-active-announcement",
    body: formData,
    verbose: verbose,
  });
};

export const requestChangeActiveEmployeeAnnouncement = async ({
  id,
  active,
  verbose = false,
}) => {
  const formData = new FormData();
  formData.append("id", id);
  formData.append("active", active);
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/change-active-employee-announcement",
    body: formData,
    verbose: verbose,
  });
};

export const requestDeleteAnnouncement = async ({ id, verbose = false }) => {
  const formData = new FormData();
  formData.append("id", id);
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/delete-announcement",
    body: formData,
    verbose: verbose,
  });
};

// EMPLOYEE ANNOUNCEMENTS REQUESTS

export const requestEmployeeAnnouncements = async ({
  hasPermission = false,
  verbose = false,
}) => {
  const formData = new FormData();
  formData.append("hasPermission", hasPermission);
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/fetch-employee-announcements",
    body: formData,
    verbose: verbose,
  });
};

export const requestSubmitNewEmployeeAnnouncement = async ({
  title,
  message,
  value,
  startDate,
  endDate,
  verbose = false,
}) => {
  const formData = new FormData();
  formData.append("title", title);
  formData.append("message", message);
  formData.append("value", value);
  formData.append("startDate", startDate);
  formData.append("endDate", endDate);
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/submit-new-employee-announcement",
    body: formData,
    verbose: verbose,
  });
};

export const requestEditEmployeeAnnouncement = async ({
  id,
  title,
  message,
  value,
  startDate,
  endDate,
  verbose = false,
}) => {
  const formData = new FormData();
  formData.append("id", id);
  formData.append("title", title);
  formData.append("message", message);
  formData.append("value", value);
  formData.append("startDate", startDate);
  formData.append("endDate", endDate);
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/edit-employee-announcement",
    body: formData,
    verbose: verbose,
  });
};

export const requestDeleteEmployeeAnnouncement = async ({
  id,
  verbose = false,
}) => {
  const formData = new FormData();
  formData.append("id", id);
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/delete-employee-announcement",
    body: formData,
    verbose: verbose,
  });
};

export const requestFetchEmployeeAnnouncementReads = async ({
  verbose = false,
}) => {
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/fetch-employee-announcement-reads",
    verbose: verbose,
  });
};

// SERVERS

export const requestServers = async ({ verbose = false }) => {
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/fetch-servers",
    verbose: verbose,
  });
};

export const requestDeletedServers = async ({ verbose = false }) => {
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/fetch-deleted-servers",
    verbose: verbose,
  });
};

export const requestSubmitNewServer = async ({
  title,
  value,
  style,
  verbose = false,
}) => {
  const formData = new FormData();
  formData.append("title", title);
  formData.append("value", value);
  formData.append("style", style);
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/submit-new-server",
    body: formData,
    verbose: verbose,
  });
};

export const requestEditServer = async ({
  id,
  title,
  value,
  style,
  verbose = false,
}) => {
  const formData = new FormData();
  formData.append("title", title);
  formData.append("value", value);
  formData.append("style", style);
  formData.append("id", id);
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/edit-server",
    body: formData,
    verbose: verbose,
  });
};

export const requestDeleteServer = async ({ id, verbose = false }) => {
  const formData = new FormData();
  formData.append("id", id);
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/delete-server",
    body: formData,
    verbose: verbose,
  });
};

// FAST ACTION EXCUSES

export const requestSetFastActionExcuses = async ({ verbose = false }) => {
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/set-fast-action-excuses",
  });
};

export const requestNewFastActionExcuse = async ({
  action,
  excuse,
  verbose = false,
}) => {
  const formData = new FormData();
  formData.append("action", action);
  formData.append("excuse", excuse);
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/new-fast-action-excuse",
    body: formData,
    verbose: verbose,
  });
};

export const requestDeleteFastActionExcuse = async ({
  action,
  excuse,
  verbose = false,
}) => {
  const formData = new FormData();
  formData.append("action", action);
  formData.append("excuse", excuse);
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/delete-fast-action-excuse",
    body: formData,
    verbose: verbose,
  });
};

export const requestEditFastActionExcuse = async ({
  action,
  prevExcuse,
  newExcuse,
  verbose = false,
}) => {
  const formData = new FormData();
  formData.append("action", action);
  formData.append("prev_excuse", prevExcuse);
  formData.append("new_excuse", newExcuse);
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/edit-fast-action-excuse",
    body: formData,
    verbose: verbose,
  });
};

// FAQs

export const requestFaqs = async ({ verbose = false }) => {
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/fetch-faqs",
    verbose: verbose,
  });
};

export const requestSubmitNewFaq = async ({
  title,
  engTitle,
  message,
  engMessage,
  value,
  verbose = false,
}) => {
  const formData = new FormData();
  formData.append("title", title);
  formData.append("engTitle", engTitle);
  formData.append("message", message);
  formData.append("engMessage", engMessage);
  formData.append("value", value);
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/submit-new-faq",
    body: formData,
    verbose: verbose,
  });
};

export const requestEditFaq = async ({
  id,
  title,
  engTitle,
  message,
  engMessage,
  value,
  verbose = false,
}) => {
  const formData = new FormData();
  formData.append("id", id);
  formData.append("title", title);
  formData.append("engTitle", engTitle);
  formData.append("message", message);
  formData.append("engMessage", engMessage);
  formData.append("value", value);
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/edit-faq",
    body: formData,
    verbose: verbose,
  });
};

export const requestDeleteFaq = async ({ id, verbose = false }) => {
  const formData = new FormData();
  formData.append("id", id);
  return secureAPICall({
    endpoint: BACKEND_URI + "/api/setup/delete-faq",
    body: formData,
    verbose: verbose,
  });
};
